<div class="col-12"></div>
<div class="col-12" >
  <div class="col-6">
    <label for="recipient">{{'UPLOAD_COMPONENT.SENDMAIL.RECIPIENT' | translate}}</label>
  </div>
  <div class="col-6">
    <input pInputText id="recipient" class="custom-input" [(ngModel)]="recipient"
           [ngClass]="{'valid': isValidMail(recipient), 'not-valid': !isValidMail(recipient)}"/>
    </div>
</div>
<div class="col-12" >
  <div class="col-9"></div>
  <div class="col-3">
<button pButton type="button" [icon]="'fa fa-check'" [label]="'COMMON.VALIDATE' | translate" class="p-button-success"
        [disabled]="!isValidMail(recipient)" (click)="closeComponent()" tabindex="0">
</button>
  </div>
</div>
